/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 10:04:21
 * @LastEditTime: 2019-09-20 11:19:02
 * @LastEditors: Please set LastEditors
 */
import { api } from '../api/api'

/** 手机号密码登录 */
const signIn = params => api('user/signIn', params)

/** 获取短信验证码 */
const getSMSCode = params => api('user/getSMSCode', params)

/** 验证码注册/登录 */
const registerLogin = params => api('user/registerLogin', params)

/** 设置密码 */
const setPassword = params => api('user/setPassword', params)

/** 忘记密码 */
const forgetPassword = params => api('user/forgetPassword', params)

/** 检查登录状态 */
const checkSession = params => api('user/checkSession', params)

/** 获取用户基础信息 */
const getUserBaseInfo = params => api('user/getUserInfo', params)


export {
  signIn,
  getSMSCode,
  registerLogin,
  setPassword,
  forgetPassword,
  checkSession,
  getUserBaseInfo
}



// WEBPACK FOOTER //
// ./src/server/user/user.js